var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.params.value)?_c('div',{staticClass:"customer-cell",attrs:{"title":_vm.params.value && _vm.params.value.name}},[_c('label',{staticClass:"customer-cell__text"},[_vm._v(_vm._s(_vm.params.value && _vm.params.value.name || ""))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }